import { render, staticRenderFns } from "./WPAccordion.vue?vue&type=template&id=09fd8316"
import script from "./WPAccordion.vue?vue&type=script&lang=ts"
export * from "./WPAccordion.vue?vue&type=script&lang=ts"
import style0 from "./WPAccordion.vue?vue&type=style&index=0&id=09fd8316&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports